import { render, staticRenderFns } from "./examredroom.vue?vue&type=template&id=8811e4d4&scoped=true&"
import script from "./examredroom.vue?vue&type=script&lang=js&"
export * from "./examredroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8811e4d4",
  null
  
)

export default component.exports